import { useSupabaseLoader } from "../../../../../server/supabase/hooks";

import type { UseSupabaseLoaderState } from "../../../../../server/supabase/hooks/types";
import type { UUID } from "../../../../../utils/uuid";
import type { FollowUpMomentDetails } from "../../../../follow-up/server/types";

export function useFollowUpMomentDetails(
  momentId: UUID,
): UseSupabaseLoaderState<FollowUpMomentDetails | null> {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const { data: existingData, error } = await supabase
        .rpc("follow_up_moment_details", {
          account_id_: account_id,
          moment_id_: momentId,
        })
        .maybeSingle();
      if (error) throw error;
      return existingData;
    },
    [momentId],
  );
}
